module.exports = __webpack_public_path__ + "static/btn 2_000018.2d827797.png";